export const addErrorDetails = (error) => {
  error.status = error?.response?.status || 500;
  error.statusCode = error?.response?.status || 500;
  error.errors = error?.response?.data?.errors || {};

  return error;
};
